export enum ComponentNameEnum {
  EntityComponent = 'EntityComponent',
  ParametersComponent = 'ParametersComponent',
  FunctionComponent = 'FunctionComponent',
  SearchComponent = 'SearchComponent',
  OperatorsComponent = 'OperatorsComponent',
  OperatorLeftPosition = 'OperatorLeftPosition',
  OperatorBottomPosition = 'OperatorButtomPosion',
  ValidateComponent = 'ValidateComponent',
}

export class NavigationEntry {
  public componentName: ComponentNameEnum;
  public icon: string;
  public toolTip: string;
  public isSelected: boolean;

  constructor() {
    //
  }
}
